import React, { useEffect, useState } from "react";
import BigNudgeToDownload from "./bigScreen";
import SmallNudgeToDownload from "./smallScreen";

const NudgeToDownload = () => {
  const [matches, setMatches] = useState(window.matchMedia("(min-width: 768px)").matches);

  useEffect(() => {
    const handler = e => setMatches(e.matches);
    const mediaQuery = window.matchMedia("(min-width: 768px)");
    mediaQuery.addEventListener('change', handler);
    return () => {
      mediaQuery.removeEventListener('change', handler);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {matches ? (<BigNudgeToDownload/>) : (<SmallNudgeToDownload/>)}
    </>
  );
};

export default NudgeToDownload;
